<template>
  <a-table
    :columns="columns"
    :row-key="(record) => record.objId"
    :data-source="data"
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    size="middle"
  >
  </a-table>
</template>
<script>
import { palyRecordData } from "@/api/Members.js";
const columns = [
  {
    title: "游玩类型",
    dataIndex: "recordDesc",
    sorter: true,
    align: "center",
    width: "10%",
  },
  {
    title: "收支类型",
    dataIndex: "shopName",
    align: "center",
    width: "8%",
  },
  {
    title: "游戏币",
    dataIndex: "recordType",
    align: "center",
    width: "15%",
  },
  {
    title: "彩票",
    dataIndex: "changeNumber",
    align: "center",
    sorter: true,
  },
  {
    title: "游玩时间",
    align: "center",
    dataIndex: "createTime",
    sorter: true,
    width: "15%",
  },
];

export default {
  data() {
    return {
      data: [],
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
    };
  },
  mounted() {
    // this.fetch();
    this.getpalyRecordData();
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      palyRecordData(10, this.pagination.current).then((res) => {
        this.data = res.data;
        console.log(res);
      });
      this.loading = false;
    },
    // 游玩记录
    getpalyRecordData() {
      let uid = this.$route.query.id;
      palyRecordData(10, 1, uid).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    fetch(params = {}) {
      this.loading = true;
      queryData({
        results: 10,
        ...params,
      }).then(({ data }) => {
        const pagination = { ...this.pagination };
        // Read total count from server
        // pagination.total = data.totalCount;
        pagination.total = 200;
        this.loading = false;
        this.data = data.results;
        this.pagination = pagination;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/memberManagement/playRecord/playRecordContent.vue